<template functional>
  <svg
    role="presentation"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="props.size"
    :height="props.size"
    viewBox="0 0 16 16"
  >
    <g>
      <path
        d="M16.083,10.025a.789.789,0,0,1,0-1.056l1.042-1.152a.789.789,0,0,0,.1-.936L15.595,4.114a.82.82,0,0,0-.871-.384l-1.531.3a.816.816,0,0,1-.936-.528l-.5-1.464a.813.813,0,0,0-.774-.544H7.729a.814.814,0,0,0-.814.544L6.458,3.506a.816.816,0,0,1-.936.528L3.95,3.73a.819.819,0,0,0-.814.384L1.508,6.882a.789.789,0,0,0,.081.936L2.623,8.969a.789.789,0,0,1,0,1.056L1.589,11.177a.789.789,0,0,0-.081.936L3.136,14.88a.82.82,0,0,0,.871.384l1.531-.3a.816.816,0,0,1,.936.528l.5,1.464a.814.814,0,0,0,.814.544h3.257a.813.813,0,0,0,.774-.544l.5-1.464a.816.816,0,0,1,.936-.528l1.531.3a.82.82,0,0,0,.871-.384l1.629-2.768a.789.789,0,0,0-.1-.936ZM14.87,11.1l.651.72-1.042,1.776-.961-.192A2.448,2.448,0,0,0,10.709,15l-.309.9H8.315l-.293-.912a2.448,2.448,0,0,0-2.809-1.6l-.961.192L3.193,11.809l.651-.72a2.368,2.368,0,0,0,0-3.2l-.651-.72L4.235,5.41,5.2,5.6A2.448,2.448,0,0,0,8.006,4l.309-.9H10.4l.309.912a2.448,2.448,0,0,0,2.809,1.6l.961-.192,1.042,1.776-.651.72a2.368,2.368,0,0,0,0,3.184ZM9.357,6.3a3.2,3.2,0,1,0,3.257,3.2A3.229,3.229,0,0,0,9.357,6.3Zm0,4.8a1.6,1.6,0,1,1,1.629-1.6A1.614,1.614,0,0,1,9.357,11.1Z"
        transform="translate(-1.391 -1.497)"
        fill="#74788d"
        stroke-width="0"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconGear',

  props: {
    size: { type: [String, Number], default: '16px' },
  }
}
</script>